import styles from "./RegisterComponent.module.css";
import { useState } from "react";
import Api from "../../../services/ApiService";
import { Card, CardBody, Row, Col, FloatingLabel, FormControl, Button, FormCheck, Spinner } from "react-bootstrap";
import EnergoSwitcher from "../../shared/EnergoSwitcher";
import Validator from "../../../services/Validator";
import CountryCodePhoneSelect from "../../shared/CountryCodePhoneSelect";
import { FaCamera, FaDotCircle, FaUpload } from "react-icons/fa";
import UploadForm from "./UploadForm";

const RegisterComponentV2 = ({}) => {

    const VALIDATOR = new Validator();
    const API = new Api();
    const [apiError, setApiError] = useState("");
    const [apiLoading, setApiLoading] = useState(false);
    const [stage, setStage] = useState("forms");
    
    var hiddenSections = ["verbrauch-form", "iwant-form", "situation-form", "upload-form"];
    const [data, setData] = useState({
        company_type: "",
        x_is_house_management: false,
        case: null,
        companyKw: false,
        contactPerson: "",
        name: "",
        lastName: "",
        email: "",
        phone_country: "+43",
        vorwahl: "",
        phone: "",
        comment: "",
        situation: "",
        uploads: []
    });
    const [fieldErros, setFieldErrors] = useState({});
    const switchOptions = [
        {id: "person", label: "Privatperson"}, 
        {id: "company", label: "Gewerbebetrieb"},
        {id: "hw", label: "Hausverwaltung"},
    ]


    const switchHandler = (opt) => {
        setFieldErrors({});
        if (opt.id === "hw") {
            setData(prev => ({ ...prev, company_type: "company", x_is_house_management: true, companyKw: true}));
        }
        else if (opt.id === "company") {
            setData(prev => ({...prev, company_type: "company", x_is_house_management: false, companyKw: false}));
        }
        else {
            setData(prev => ({...prev, company_type: "person", x_is_house_management: false, companyKw: false}));
        }
    }

    const nextBtnHandler = (sectionId) => {
        var tmpError = {};
        var next = null; 

        // checks 
        if (sectionId === "info-form") {
            if (data.company_type === "") tmpError.company_type = true;
            if (data.name === "") tmpError.name = true;
            if (data.company_type === "person") {
                if (data.lastName === "") tmpError.lastName = true;
            } else {
                if (data.contactPerson === "") tmpError.contactPerson = true;
            }
            if (data.phone_country === "") tmpError.phone_country = true;
            if (data.vorwahl === "") tmpError.vorwahl = true;
            if (data.phone === "") tmpError.phone = true;
            if (!VALIDATOR.EmailValid(data.email)) tmpError.email = true;
            
        }
        if (sectionId === "iwant-form") {
            if (data.case === null) tmpError.case = true;
        }
        if (sectionId === "situation-form") {
            if (data.situation === "") tmpError.situation = true;
        }
        if (Object.keys(tmpError).length > 0) return setFieldErrors(tmpError);
        
        // next handlers
        if (sectionId === "info-form") {
            if (data.x_is_house_management === true) return createTicket();
            if (data.company_type === "person") next = "iwant-form";
            else next = "verbrauch-form";
        }
        if (sectionId === "verbrauch-form") {
            if (data.companyKw === true) return createTicket();
            else next = "iwant-form";
        }
        if (sectionId === "iwant-form") {
            if (data.case === 5) return registerUser();
            else next = "situation-form"
        }
        if (sectionId === "situation-form") {
            next = "upload-form";
        }
        
        console.log(next)
        if (next !== null) {
            document.getElementById(next).removeAttribute('hidden');
            return document.getElementById(next).scrollIntoView({behavior: "smooth"});
        }

    }


    const createTicket = () => {
        setApiLoading(true);
        let dataForSending = {...data};
        dataForSending.phone = `${data.phone_country} ${data.vorwahl} ${data.phone}`;
        API.angebot_einholen(dataForSending)
            .then(() => {setStage("ticket_done"); setApiLoading(false)})
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStage("error");
                setApiLoading(false);
            });
    }

     const registerUser = () => {
        setApiLoading(true);
        let dataForSending = {...data};
        dataForSending.phone = `${data.phone_country} ${data.vorwahl} ${data.phone}`;
        API.register_basic(dataForSending)
            .then(() => {setStage("reg_done"); setApiLoading(false)})
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStage("error");
                setApiLoading(false);
            })
    }


    return (
        stage === "forms" ?
            <>
                <div id="info-form">
                    <h1 className="text-center">Hier gehts zum Formular:</h1>
                    <Card className={styles.shadowcard}>
                        <CardBody>
                            <p className={styles.formdescription}>Wohin dürfen wir Ihr persönliches Angebot senden?</p>
                            <Row className="mt-3">
                                <Col xs="12">
                                    Ich bin ...
                                    <div className="d-flex" style={fieldErros.company_type? {border: "1px solid red"}: null}>
                                        <EnergoSwitcher options={switchOptions} handler={switchHandler} selected={data.x_is_house_management? "hw" : data.company_type} />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xs="12" md="6" xl="6">
                                    <FloatingLabel label={data.company_type === "company" ? "Unternehmensbezeichnung" : "Vorname"}>
                                        <FormControl 
                                            className={styles.inputform}
                                            placeholder={data.company_type === "company" ? "Unternehmensbezeichnung" : "Vorname"} 
                                            value={data.name}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, name: e.target.value})) }}
                                            isValid={data.name !== ""}
                                            isInvalid={fieldErros.name}
                                        />
                                    </FloatingLabel>
                                </Col>
                                <Col xs="12" md="6" xl="6" hidden={data.company_type === "company"}>
                                    <FloatingLabel label="Nachname">
                                        <FormControl 
                                            className={styles.inputform}
                                            placeholder="Nachname"
                                            value={data.lastName}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, lastName: e.target.value})) }}
                                            isValid={data.lastName !== ""}
                                            isInvalid={fieldErros.lastName}
                                        />
                                    </FloatingLabel>
                                </Col>
                                <Col xs="12" md="6" xl="6" hidden={data.company_type !== "company"}>
                                    <FloatingLabel label="Kontaktperson">
                                        <FormControl
                                            className={styles.inputform}
                                            placeholder="Kontaktperson"
                                            value={data.contactPerson}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, contactPerson: e.target.value})) }}
                                            isValid={data.contactPerson !== ""}
                                            isInvalid={fieldErros.contactPerson}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xs="12" md="8" xl="8">
                                    <FloatingLabel label="E-Mail">
                                        <FormControl 
                                            className={styles.inputform}
                                            placeholder="E-Mail"
                                            value={data.email}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, email: e.target.value})) }}
                                            isValid={VALIDATOR.EmailValid(data.email)}
                                            isInvalid={fieldErros.email}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <CountryCodePhoneSelect data={data} setData={setData} />
                                </Col>
                                <Col>
                                    <FloatingLabel label="Vorwahl">
                                        <FormControl
                                            className={styles.inputform}
                                            type="phone"
                                            placeholder="Vorwahl"
                                            value={data.vorwahl}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, vorwahl: e.target.value})) }}
                                            isValid={data.vorwahl !== "" && VALIDATOR.IsNumeric(data.vorwahl)}
                                            isInvalid={fieldErros.vorwahl}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <FloatingLabel label="Telefonnummer">
                                        <FormControl
                                            className={styles.inputform}
                                            type="phone"
                                            placeholder="Telefonnummer"
                                            value={data.phone}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, phone: e.target.value})) }}
                                            isValid={data.phone !== "" && VALIDATOR.IsNumeric(data.phone)}
                                            isInvalid={fieldErros.phone}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <Button 
                                        disabled={apiLoading}
                                        onClick={() => nextBtnHandler("info-form")} 
                                        className={styles.nextbtn} 
                                        variant="energo"
                                    >
                                        {apiLoading? 
                                            <Spinner animation="border" /> :
                                            data.x_is_house_management === true? "Absenden":"Weiter"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
                <div className={styles.formsection} id="verbrauch-form" hidden>
                    <h1 className="text-center">Ihr Verbrauch:</h1>
                    <Card className={styles.formcard}>
                        <CardBody>
                            <p className={styles.formdescription}>
                                Ich verbrauche pro Jahr mehr als 100.000 kWh Strom und/oder 400.000 kWh Gas.
                            </p>
                            <Row className="mt-5">
                                <Col>
                                    <FormCheck
                                        type="checkbox"
                                        label="Ja"
                                        checked={data.companyKw === true}
                                        onChange={() => {setFieldErrors({}); setData(prev => ({...prev, companyKw: true})) }}
                                    />
                                    <FormCheck
                                        type="checkbox"
                                        label="Nein"
                                        checked={!data.companyKw}
                                        onChange={() => {setFieldErrors({}); setData(prev => ({...prev, companyKw: false})) }}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <Button
                                        disabled={apiLoading}
                                        className={styles.nextbtn} 
                                        variant="energo"
                                        onClick={() => nextBtnHandler('verbrauch-form')}
                                    >
                                        {apiLoading?
                                            <Spinner animation="border" /> :
                                            data.companyKw ? "Absenden" : "Weiter"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
                <div id="iwant-form" className={styles.formsection} hidden>
                    <h1 className="text-center">Was ist Ihr Wunsch?</h1>
                    <Card className={styles.formcard}>
                        <CardBody>
                            <p className={styles.formdescription}>Ich möchte ...</p>
                            <div className="p-3">
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Den Strom/Gas-Vertrag wechseln / ein Angebot einholen."
                                    checked={data.case === 6}
                                    onChange={() => {setFieldErrors({}); setData(prev => ({...prev, case: 6})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Strom/Gas neu anmelden."
                                    checked={data.case === 5}
                                    onChange={() => {setFieldErrors({}); setData(prev => ({...prev, case: 5})) }}
                                />
                            </div>
                            <br /><br />
                            <p className={styles.formdescription} hidden={data.case !== 6}>
                                Es besteht ein laufender Energieliefervertrag auf meinen Namen. 
                                Ich möchte ein unverbindliches Angebot einholen und mehr Informationen 
                                zur Dienstleistung von ENERGO.
                            </p>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <Button 
                                        disabled={apiLoading}
                                        className={styles.nextbtn} 
                                        variant="energo"
                                        onClick={() => nextBtnHandler("iwant-form")}
                                    >
                                        {apiLoading?
                                            <Spinner animation="border" /> :
                                            data.case === 5 ? "Absenden" : "Weiter"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
                <div id="situation-form" className={styles.formsection} hidden>
                    <h1 className="text-center">Wie ist der Stand der Dinge?</h1>
                    <Card className={styles.formcard}>
                        <CardBody>
                            <p className={styles.formdescription}>
                                Um Ihnen bestmöglich helfen zu können, möchten wir gerne wissen in
                                welcher Situation Sie sich gerade befinden:
                            </p>
                            <div className="mt-3" style={fieldErros.situation? {border: "1px solid red"}:null}>
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"
                                    value="Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"
                                    checked={data.situation === "Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Vertragskündigung des Stromanbieterst OHNE Folgeangebot"
                                    value={"Vertragskündigung des Stromanbieterst OHNE Folgeangebot"}
                                    checked={data.situation === "Vertragskündigung des Stromanbieterst OHNE Folgeangebot"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Höheres Folgeangebot bereits angenommen"
                                    value={"Höheres Folgeangebot bereits angenommen"}
                                    checked={data.situation === "Höheres Folgeangebot bereits angenommen"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"
                                    value={"Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"}
                                    checked={data.situation === "Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Börsenabhängiger Flex-/Floattarif"
                                    value={"Börsenabhängiger Flex-/Floattarif"}
                                    checked={data.situation === "Börsenabhängiger Flex-/Floattarif"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Keine der genannten"
                                    value={"Keine der genannten"}
                                    checked={data.situation === "Keine der genannten"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                            </div>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <Button onClick={() => nextBtnHandler("situation-form")} className={styles.nextbtn} variant="energo">Weiter</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
                <div id="upload-form" className={styles.formsection} hidden>
                    <h1 className="text-center">Ihre aktuellste Jahresabrechnung:</h1>
                    <UploadForm data={data} setData={setData} setStage={setStage} setApiError={setApiError} />
                </div>
            </> :

        null
    )
}
export default RegisterComponentV2;